import React from 'react';

const MemberProfileItem = ({ members, customStyles = {} }) => {
  return (
    <div>
      {members.map((member, index) => (
        <div key={index}>
          <div className="label" style={customStyles.label}>{member.label}</div>
          <div className="value" style={customStyles.value}>{member.value}</div>
        </div>
      ))}
    </div>
  );
};

export default MemberProfileItem;
